// extracted by mini-css-extract-plugin
module.exports = {"tinySectionTitle":"TinySectionTitle_tinySectionTitle__KI_zy","dot":"TinySectionTitle_dot__sw5eB"};